<template>
  <div class="row row-container">
    <div class="col">
      <div :bg-row="`${getRowColor(value)}`" class="row">
        <div class="col-2 col-sm col-12 border-right status pt-2">
          <div class="row">
            <div class="col-5 col-md-12">
              <balloon
                :bg="`bg-${getColor(value.assistanceApprovalStatusCd)}`"
                class="w-md-90 w-100 mt-2 font-weight-normal font-16 d-flex justify-content-center align-items-center"
                color="font-weight-bold"
                pill-content-class="justify-content-center"
                :text="value.assistanceApprovalStatusName"
                :with-border="false"
              />
            </div>
            <div class="col-sm col-5 col-md-12 col text-center my-3">
              <div class="color-secondary-6 font-14 font-weight-normal">
                Servicio:
              </div>
              <span class="color-black font-16 font-weight-bold">
                {{ value.serviceDescription }}
              </span>
            </div>
            <div
              class="col-sm col-2 col-md col d-md-none d-sm-block d-flex align-items-center"
            >
              <check-box v-model="value.isChecked" class="checkbox mt-3" />
            </div>
          </div>
        </div>
        <div
          class="col-3 col-sm col-12 pl-md-3 pl-md-4 pl-sm-4 mt-4 mt-md-4 mt-sm-4 pt-md-3"
        >
          <div class="color-secondary-6 font-14 font-weight-normal">
            Estudiante:
          </div>
          <span class="color-black font-16 font-weight-bold">
            {{ value.studentSieId }} - {{ value.fullName | capitalize }}
          </span>
        </div>
        <div class="col-2 col-sm col-6 mt-3 mt-md-4 mt-sm-4 pt-md-3">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Periodo:
          </div>
          <span class="color-black font-16 font-weight-bold">
            {{ value.period }}
          </span>
        </div>
        <div class="col-2 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Fecha de Nómina:
          </div>
          <span class="color-black font-16 font-weight-bold">
            {{ value.payrollDate | date }}
          </span>
        </div>
        <div class="col-1 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3">
          <div class="color-secondary-6 font-14 font-weight-normal">
            Asistencias:
          </div>
          <div class="d-flex align-items-center">
            <span class="color-black font-16 font-weight-bold ml-1">
              {{ value.assistanceDetailCount || '-' }}
            </span>
          </div>
        </div>
        <div class="col-1 col-sm col-6 mt-4 mt-md-4 mt-sm-4 pt-md-3">
          <div v-show="!isRelatedPayment">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Total:
            </div>
            <span
              class="color-black font-16 font-weight-normal font-weight-bold"
            >
              {{ value.costTotalAmt | price }}
            </span>
          </div>
        </div>
        <div
          class="col-12 col-sm col-6 text-center mt-4 mt-md-4 mt-sm-4 pr-5 pt-4"
        >
          <drop-down
            class="actions-dropdown"
            :data-item="{ value, index }"
            :items="actionItems"
          />
        </div>
        <div class="pl-3 d-sm-none d-md-block border-left my-3 pt-3">
          <check-box
            v-if="
              getStatus(value.assistanceApprovalStatusCd) &&
                !isChildRelation(value)
            "
            v-model="value.isChecked"
            class="checkbox d-flex justify-content-center align-items-center mt-4"
            text=""
          />
        </div>
        <div class="col-md-12 ml-n0 ml-md-n5 ml-sm-n0 mt-3 mt-md-0 mt-sm-3">
          <div class="row ml-n1">
            <div class="col-md-2 ml-n1 border-right" />
            <div class="col-md-7">
              <payment-tags v-model="value" />
            </div>
            <div
              v-if="showRemaingDays"
              class="col-md-2"
              style="text-align: right"
            >
              Días en Vencimiento:
            </div>
            <div
              v-if="showRemaingDays"
              class="col-md-1"
              :color="`${getCountColor(value)}`"
            >
              {{ value.daysInPayroll }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-1" style="max-width: 70px !important;">
      <compact-nav-tabs
        :value="generalTabIndex"
        @on-select-tab-index="$emit('on-select-tab-index', $event)"
      />
    </div>
  </div>
</template>

<script>
import PaymentTags from './PaymentTags';
import CompactNavTabs from './CompactNavTabs';
import statusEnum from '@/views/scholarship/attendance/utils/statusEnum.js';
import { Colors } from '@/components/common';
import alertMixin from '@/mixins/alert.mixin';
import serviceTypeEnum from '@/views/scholarship/attendance/utils/serviceTypeEnum.js';
import payrollReceiveTypesEnum from '@/views/scholarship/attendance/utils/payrollReceiveTypesEnum.js';
export default {
  name: 'RowStandard',
  components: {
    PaymentTags,
    CompactNavTabs,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    generalTabIndex: {
      type: Number,
      default: null,
    },
    showRemaingDays: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    errorClass() {
      return this.errors.length > 0 ? 'bg-error' : '';
    },
    getColor() {
      return (status) => {
        switch (status) {
          case statusEnum.payment:
            return 'primary-15';
          case statusEnum.approved:
            return 'secondary-36';
          case statusEnum.pending:
          case statusEnum.no_payment:
            return Colors.YELLOW;
          case statusEnum.denegate:
            return Colors.BROWN;
          case statusEnum.review:
            return 'secondary-16';
        }
      };
    },
    getCountColor() {
      return (value) => {
        return value.remingDaysClass;
      };
    },
    getStatus() {
      return (status) => {
        switch (status) {
          case statusEnum.pending:
            return true;
          case statusEnum.denegate:
            return true;
          case statusEnum.review:
            return true;
          default:
            return false;
        }
      };
    },
    actionItems() {
      return [
        {
          name: 'documentpayroll',
          label: 'Documentar Nómina',
          icon: 'fas fa-file-invoice color-primary-1 pr-2',
          click: ({ value, index }) => {
            this.$emit('document-payroll', { value, index });
          },
          visible: ({ value }) => {
            const validReceiveTypes = [
              payrollReceiveTypesEnum.FacturacionEnLineaSAEE,
              payrollReceiveTypesEnum.FacturacionEnLineaRP,
            ];
            if (
              validReceiveTypes.includes(value.payrollReceiveTypeId) ||
              value.assistanceApprovalStatusCd !== statusEnum.pending
            ) {
              return false;
            }
            switch (this.isPublic()) {
              case 1:
                return (
                  [
                    serviceTypeEnum.terapiaDeHabla,
                    serviceTypeEnum.terapiaOcupacional,
                    serviceTypeEnum.terapidaPsicologica,
                    serviceTypeEnum.terapiaFisica,
                    serviceTypeEnum.terapiaOromotora,
                    serviceTypeEnum.terapiaDisfagia,
                    serviceTypeEnum.otros,
                  ].includes(value.peiAnalysisServiceId) &&
                  ![
                    statusEnum.review,
                    statusEnum.no_payment,
                    statusEnum.payment,
                    statusEnum.approved,
                    statusEnum.denegate,
                  ].includes(value.assistanceApprovalStatusCd) &&
                  !this.isChildRelation(value)
                );
              default:
                return (
                  [
                    serviceTypeEnum.terapiaDeHabla,
                    serviceTypeEnum.terapiaOcupacional,
                    serviceTypeEnum.terapidaPsicologica,
                    serviceTypeEnum.terapiaFisica,
                    serviceTypeEnum.terapiaOromotora,
                    serviceTypeEnum.terapiaDisfagia,
                    serviceTypeEnum.otros,
                    serviceTypeEnum.educativo,
                  ].includes(value.peiAnalysisServiceId) &&
                  ![
                    statusEnum.review,
                    statusEnum.no_payment,
                    statusEnum.payment,
                    statusEnum.approved,
                  ].includes(value.assistanceApprovalStatusCd) &&
                  !this.isChildRelation(value)
                );
            }
          },
        },
        {
          name: 'restart payroll',
          label: 'Reiniciar Nómina',
          icon: 'fas fa-undo color-primary-1 pr-1',
          visible: ({ value }) => {
            const validReceiveTypes = [
              payrollReceiveTypesEnum.FacturacionEnLineaSAEE,
              payrollReceiveTypesEnum.FacturacionEnLineaRP,
            ];
            if (
              validReceiveTypes.includes(value.payrollReceiveTypeId) ||
              this.isPublic()
            ) {
              return false;
            }
            return (
              value.assistanceApprovalStatusCd == statusEnum.pending &&
              value.payrollDate &&
              value.isManualAssistanceFlag
            );
          },
          click: () => this.$emit('restart-payroll', { ...this.value }),
        },
        {
          name: 'relate payment',
          label: 'Relación de pago',
          icon: 'fas fa-people-arrows color-primary-2 pr-1',
          visible: ({ value }) => {
            return (
              (value.assistanceApprovalStatusCd == statusEnum.pending ||
                value.assistanceApprovalStatusCd == statusEnum.approved ||
                value.assistanceApprovalStatusCd == statusEnum.payment) &&
              !this.isChildRelation(value)
            );
          },
          click: () =>
            this.$emit('payment-relationship', this.index, this.value),
        },
        {
          name: 'additional payment',
          label: 'Pago adicional',
          icon: 'fas fa-plus-circle color-primary-2 pr-2',
          click: () => this.$emit('additional-payment', this.index, this.value),
          border: 'bottom',
          visible: ({ value }) => {
            return (
              [statusEnum.payment].includes(value.assistanceApprovalStatusCd) &&
              !this.isChildRelation(value)
            );
          },
        },
        {
          name: 'tracing',
          label: 'Comentario',
          icon: 'fas fa-comment color-primary-1 pr-2',
          click: () => this.$emit('follow-up', this.index, this.value),
        },
        {
          name: 'restart',
          label: 'Reiniciar Estatus',
          icon: 'fas fa-redo-alt color-primary-1 pr-2',
          visible: ({ value }) => {
            return (
              this.userHasPermissions(
                'menu.scholarship.paymentmanagement.resetstatus'
              ) &&
              [
                statusEnum.approved,
                statusEnum.denegate,
                statusEnum.review,
              ].includes(value.assistanceApprovalStatusCd) &&
              !this.isChildRelation(value)
            );
          },
          click: () => this.$emit('restart-status', { ...this.value }),
        },
        {
          name: 'visits certification',
          label: 'Certificación de Visitas',
          icon: 'fas fa-user-check color-primary-1 pr-1',
          click: () =>
            this.$emit('certification-document', this.index, this.value),
          visible: ({ value }) => {
            return [
              payrollReceiveTypesEnum.FacturacionEnLineaSAEE,
              payrollReceiveTypesEnum.FacturacionEnLineaRP,
            ].includes(value.payrollReceiveTypeId);
          },
        },
        {
          name: 'manual adjustment',
          label: 'Ajuste Manual de Asistencia',
          icon: 'fas fa-file-edit color-primary-8 pr-2 pl-1',
          click: () => this.$emit('manual-adjustment', this.index, this.value),
          visible: ({ value }) => {
            return (
              ![
                statusEnum.review,
                statusEnum.no_payment,
                statusEnum.payment,
                statusEnum.approved,
                statusEnum.denegate,
              ].includes(value.assistanceApprovalStatusCd) &&
              !this.isChildRelation(value)
            );
          },
        },
        {
          name: 'denegate assistance',
          label: 'Denegar Asistencia',
          icon: 'fas fa-times-circle color-primary-4 pr-1 pl-1',
          click: () =>
            this.$emit('denegate-assistance', this.index, this.value),
          visible: ({ value }) => {
            return (
              [statusEnum.pending, statusEnum.approved].includes(
                value.assistanceApprovalStatusCd
              ) && !this.isChildRelation(value)
            );
          },
        },
      ];
    },
    isRelatedPayment() {
      return (
        this.value.summaryParentId != null &&
        this.value.summaryParentId != this.value.assistanceSummaryId
      );
    },
  },
  methods: {
    isPublic() {
      return this.value.isManualAssistanceFlag ? null : 1;
    },
    isChildRelation(item) {
      return (
        item.summaryParentId != null &&
        item.summaryParentId != item.assistanceSummaryId
      );
    },
    getRowColor(value) {
      if (this.showRemaingDays == false) return;
      let diffDays = value.daysInPayroll;
      if (diffDays > 40 && diffDays < 60) {
        return 'semi-yellow';
      } else if (diffDays >= 60) {
        value.remingDaysClass = 'color-red';
        return 'semi-red';
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/fonts.scss';
@import '~@/shared/scss/config/colors.scss';

div[bg-row='semi-red'] {
  background-color: #ffebeb;
}

div[bg-row='semi-yellow'] {
  background-color: #fff8e3;
}

div[bg-row='semi-yellow'] {
  background-color: #fff8e3;
}

div[color='color-red'] {
  color: #c9545e;
}

@media only screen and (max-width: 768px) {
  .row-container {
    div,
    span {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
    .status {
      border-right: unset !important;
      border-bottom: 1px solid map-get($colors, 'secondary-12');
      padding-bottom: map-get($fontsSize, 'font-10');
    }
  }

  ::v-deep .reason {
    em {
      font-size: map-get($fontsSize, 'font-10') !important;
    }
    .text-left {
      font-size: map-get($fontsSize, 'font-12') !important;
    }
  }

  .actions-dropdown {
    ::v-deep {
      .dropdown-toggle {
        width: 100%;
        font-size: 12px;
      }
    }
  }
}
</style>
